import React from "react";
import Stack from "./Stack";
const Loader = () => {
    return (
        <Stack className="align-items-center justify-content-center bg-body position-absolute w-100 h-100 z-3">
            <h5>Loading...</h5>
        </Stack>
    )
};
export default Loader;
